import { ModernSearchHit, SearchDisplay } from "frontend/types";
import { isSearchHitType } from "./is-search-hit-type";
import { ParticipantStoryTeaseProps } from "design-system/components/primitives/participant-story-tease/participant-story-tease";

export function createModernSearchParticipantStoryTease(
  data?: ModernSearchHit | SearchDisplay,
): ParticipantStoryTeaseProps | undefined {
  if (data && typeof data === "object") {
    const props: ParticipantStoryTeaseProps = {
      type: "ParticipantStory",
      link: data.url,
    };

    //get image path from data.display.thumbnail.source
    if (isSearchHitType<SearchDisplay>("modern", data)) {
      if (data.display?.thumbnail?.src) {
        props.image = {
          src: data.display?.thumbnail.src,
        };
        if (data.display?.thumbnail.gravity) {
          props.image.gravity = data.display?.thumbnail.gravity;
        }
      } else {
        props.subtitle = data.title;
      }

      if (data.display?.participantStoryName) {
        props.name = data.display?.participantStoryName;
      }

      if (data.display?.participantStoryRole) {
        props.role = data.display?.participantStoryRole;
      }
    }

    return props;
  }
}
